export default __webpack_public_path__ + "static/blogs-img-1-17a164cdd0836d391e1116100a5ba72f.png";